'use strict';

// TODO Remove card container. Move logic and modal template to contractingPartnerService.
import { BaseController } from '../../base/controller';

export class CardContainerController extends BaseController {
  constructor($rootScope, controllerService, cardService, contractringPartnersTemplate) {
    'ngInject';
    super({ $rootScope, controllerService, cardService, contractringPartnersTemplate });
  }

  $onInit() {
    this.clearCongtractingPartnerModel();
    this.cardService.onEdit((cp) => {
      this.clearCongtractingPartnerModel(cp);
    });
  }

  clearCongtractingPartnerModel(cp) {
    const edit = !!cp;
    this.contractingPartner = cp || angular.copy(this.defaultUser) || {};
    if (!edit) {
      this.contractingPartner.id = Math.random();
    }
  }

  cancelAddingContractingPartner(modal) {
    this.clearCongtractingPartnerModel();
    modal.dismiss();
  }

  addContractingPartner(form, modal) {
    form.$submitted = true;
    if (!form.$invalid) {
      const contractingPartner = angular.copy(this.contractingPartner);

      this.cardService.addContractingPartner(contractingPartner);
      modal.close(contractingPartner);
      this.clearCongtractingPartnerModel();
      this.$rootScope.$broadcast('newContractingPartners', contractingPartner);
    }
  }
}
